import {
  styled,
  Table,
  TableCell,
  TableCellProps,
  TableHead,
  TableHeadProps,
  TableProps,
  TableRow,
  TableRowProps,
} from '@mui/material'

export const StyledTableCell = styled((props: TableCellProps) => <TableCell {...props} />)(() => ({
  '&.MuiTableCell-body': {
    color: '#fff',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    padding: '16px',
    border: '0',
    backgroundColor: '#1E2735',
  },
  '&.MuiTableCell-body:first-child': {
    paddingLeft: '24px',
  },
  '&.MuiTableCell-body:last-child': {
    paddingLeft: '24px',
  },
  '&.MuiTableCell-head': {
    color: '#C2CBD9',
    border: '0',
    fontSize: '14px',
    lineHeight: '20px',
    padding: '8px 12px',
  },
  '&.MuiTableCell-head:first-child': {
    paddingLeft: '24px',
  },
  '&.MuiTableCell-head:last-child': {
    paddingLeft: '24px',
  },
}))

export const StyledTableRow = styled((props: TableRowProps) => <TableRow {...props} />)(() => ({
  '&': {
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },
  '&:last-child': {
    borderBottom: '0',
  },
}))

export const StyledTableHead = styled((props: TableHeadProps) => <TableHead {...props} />)(() => ({
  '&': {
    backgroundColor: 'rgba(7, 13, 21, 0.4)',
  },
}))

export const StyledTable = styled((props: TableProps) => <Table {...props} />)(() => ({
  '&': {
    borderRadius: '8px',
    overflow: 'hidden',
  },
}))
